<template>
  <div class="no-con-wrap">
    <img :src="url" class="no-img" :style="_style" />
    <div class="no-content">{{content}}</div>
  </div>
</template>

<script>
export default {
  name: "ContentEmpty",
  props: {
    content: String,
    url: String,
    _style: Object
  }
};
</script>

<style lang="stylus" scoped>
.no-con-wrap {
  padding-bottom: 120px;
}

.no-img {
  display: block;
  width: 2rem;
  height: 2rem;
  margin: 80px auto 0;
}

.no-content {
  font-size: 15px;
  color: #b8b8b8;
  text-align: center;
  margin-top: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/v2/Empty.vue